export const enUS = {
  yes:'Yes',
  no:'No',
  }
